import { useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { GlobalStateContext } from 'context/GlobalContextProvider'

// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'
import Title from 'components/Title'

import InstagramCount from 'components/InstagramCount'
import TiktokCount from 'components/TiktokCount'

import HeaderBio from './HeaderBio'
import s from './ModelHeader.module.css'

function ModelHeader({
  firstName = '',
  lastName = '',
  coverImage = null,
  bio = '',
  instagram = [],
  tiktok = [],
  uiColour = false,
}) {
  const imgHalfRef = useRef(null)
  const titleContainerRef = useRef(null)

  const state = useContext(GlobalStateContext)

  if (!coverImage) return null

  // Forcing the character case because client doesn't want to change in CMS.
  const name = `${firstName?.toLowerCase() || ''} ${
    lastName?.toLowerCase() || ''
  }`

  // NOTE: This has been added quckly to get a retina version of the header image.
  // If more time was allocated I would look at using 'dpr_auto' and the Cloudinary React SDK
  // to handle images.
  const cloudinaryUrl = `https://res.cloudinary.com/select-models/image/fetch/w_2560,c_limit`
  const ratio = '3:4'
  const imgNormal = `${cloudinaryUrl}/w_1.0,c_fit,ar_${ratio},f_auto,q_auto:best/${coverImage}`
  const imgRetina = `${cloudinaryUrl}/w_1.0,c_fit,ar_${ratio},f_auto,q_auto:best,dpr_2.0/${coverImage}`

  const setImage = (
    <img
      src={imgNormal}
      srcSet={`${imgNormal} 1x, ${imgRetina} 2x`}
      alt={name}
      className={s.img}
    />
  )

  const renderImage = () => {
    return (
      <div className={s.imgHalfWrap}>
        <div className={s.imgHalf} ref={imgHalfRef}>
          {setImage}
        </div>
      </div>
    )
  }

  // const headerBackground =
  //   headerColour && headerColour === 'light' ? '#000' : '#fff'

  return (
    <div className={classNames(s.container, s.containerPortrait)}>
      <div className={s.text}>
        <div className={s.textContent}>
          <div className={s.titleContainer} ref={titleContainerRef}>
            <Title
              className={s.title}
              title={firstName}
              subtitle={lastName}
              lightUi={uiColour === true}
              shrinkSubtitleLength={15}
            />
            <div className={s.socialStats}>
              {instagram && (
                <InstagramCount
                  instagram={instagram}
                  colour={uiColour === true ? '#fff' : '#000'}
                />
              )}
              <TiktokCount
                tiktok={tiktok}
                colour={uiColour === true ? '#fff' : '#000'}
              />
            </div>
          </div>
          <HeaderBio
            bio={bio}
            imgHalfRef={imgHalfRef}
            titleContainerRef={titleContainerRef}
          />
        </div>
      </div>
      {renderImage()}
    </div>
  )
}

ModelHeader.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  coverImage: PropTypes.string,
  bio: PropTypes.string,
  instagram: PropTypes.array,
  tiktok: PropTypes.array,
  uiColour: PropTypes.bool,
}

export default ModelHeader
